// extracted by mini-css-extract-plugin
export default {"container":"AuthLayout_container__IL01d","card":"AuthLayout_card__qJTqW","logo":"AuthLayout_logo__vMRZ0","title":"AuthLayout_title__VIoVB"};